import React from 'react';
import { PageHeader } from '../components/common/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import { ScoringEngine } from '../components/ai/ScoringEngine';
import { RecommendationLibrary } from '../components/ai/RecommendationLibrary';
import { ReportGenerator } from '../components/ai/ReportGenerator';
export function AiHub() {
  return <div data-id="element-1110" data-mp="147tngyhhhovc">
      <PageHeader eyebrow="Intelligence" title="AI intelligence hub" description="Configure the scoring engine, maintain the preset recommendation library, and generate reports. Every output is advisory and attributable — officers record the decision." data-id="element-1111" data-mp="147adq51zm6se" />

      <div className="p-6" data-id="element-1112" data-mp="z87amq5kian2">
        <Tabs defaultValue="scoring" data-id="element-1113" data-mp="z7e67vu2zx83">
          <TabsList data-id="element-1114" data-mp="zajw3dajb34v">
            <TabsTrigger value="scoring" data-id="element-1115" data-mp="3ezv2i75q5cz0">Scoring engine</TabsTrigger>
            <TabsTrigger value="recommendations" data-id="element-1116" data-mp="3f1obvu7q2bap">Recommendation library</TabsTrigger>
            <TabsTrigger value="reports" data-id="element-1117" data-mp="3k09bpsj2asym">Report generator</TabsTrigger>
          </TabsList>
          <TabsContent value="scoring" className="mt-4" data-id="element-1118" data-mp="1725qnkzn0qb5">
            <ScoringEngine data-id="element-1119" data-mp="1302cupphx9mp" />
          </TabsContent>
          <TabsContent value="recommendations" className="mt-4" data-id="element-1120" data-mp="131lqe8jrp6ks">
            <RecommendationLibrary data-id="element-1121" data-mp="1gzts0trr0w2a" />
          </TabsContent>
          <TabsContent value="reports" className="mt-4" data-id="element-1122" data-mp="1gx7fefq03qd7">
            <ReportGenerator data-id="element-1123" data-mp="1bzp9ky7a5r9f" />
          </TabsContent>
        </Tabs>
      </div>
    </div>;
}